import useStaffAttendance from "./use-staff-attendance";
import useStaffCheckQr from "./use-staff-check-qr";
import useStaffWorkerSessions from "./use-staff-worker-sessions";


const StaffManagementHooks = {
    useStaffAttendance,
    useStaffCheckQr,
    useStaffWorkerSessions,
};

export default StaffManagementHooks;
